import styled from 'styled-components';

export const Title = styled.h1`
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-bottom: 24px;
`;

export const EmptyMessage = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Centered = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
